<template>
  <div class="list-group-item contact d-flex justify-content-between">
    <div>
      <span v-html="checkForMarking(client.kdnr)"/> <span v-html="checkForMarking(client.name)"/>
      <template v-if="client.email">
        - <span v-html="checkForMarking(client.email)"/>
      </template>
      <div v-if="isPhoneSearch && client.phones?.length" class="small">
        <template v-for="(phone, index) in client.phones" :key="index">
          <span :class="{'fw-bold': phoneMatches(phone)}" class="me-3 text-nowrap">
            <i class="fa-solid fa-phone"></i> <span v-html="highlightPhone(phone.number)"/><template v-if="phone.label"> ({{ phone.label }})</template>
          </span>
        </template>
      </div>
    </div>
    <router-link class="ms-3 btn btn-primary btn-sm"
                 :to="{name: ROUTES.CLIENTS.SHOW, params: {id: client.id}}">
      <i class="fa-solid fa-users-between-lines"></i> {{ $t('clients.show') }}
    </router-link>
  </div>
</template>
<script>

import {ROUTES} from "@/scripts/constants";
import {highlightPhone, isPhoneSearch, phoneSearchDigits} from "@/scripts/phone_search";

export default {
  name: 'ClientButton',
  props: {
    searchString: String,
    client: Object,
  },
  setup() {
    return {
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  computed: {
    ROUTES() {
      return ROUTES
    },
    searchDigits() {
      return phoneSearchDigits(this.searchString)
    },
    isPhoneSearch() {
      return isPhoneSearch(this.searchString)
    },
  },
  methods: {
    phoneMatches(phone) {
      return Boolean(phone.e164 && phone.e164.includes(this.searchDigits))
    },
    highlightPhone(number) {
      return highlightPhone(number, this.searchString)
    },
    checkForMarking(text) {
      if (text) {
        const regex = new RegExp(this.searchString, 'gi');
        text = text.replace(/(<mark class="highlight">|<\/mark>)/gim, '');
        return text.replace(regex, '<mark class="highlight">$&</mark>');
      }
      return ''
    },
  },
}
</script>